const deprecationPlanEndpoints = {
  list: (companyId: string) => `/companies/${companyId}/reporting/financial-statement/deprecation-plans` as const,
  detail: (companyId: string, id: number) => `/companies/${companyId}/budgeting/deprecation-plans/${id}` as const,
  create: (companyId: string) => `/companies/${companyId}/budgeting/deprecation-plans` as const,
  update: (companyId: string, id: number) => `/companies/${companyId}/budgeting/deprecation-plans/${id}` as const,
  delete: (companyId: string, id: number) => `/companies/${companyId}/budgeting/deprecation-plans/${id}` as const
}

export default deprecationPlanEndpoints
